module.exports = __webpack_public_path__ + "img/dystop.11429949.png";